import { ReactNode, type CSSProperties } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import { SIDEBAR_DIMENSIONS, ANIMATION_DURATION } from "./constants";

interface UILogoProps {
  logo: ReactNode;
  href?: string;
  isCollapsed: boolean;
  className?: string;
  style?: CSSProperties;
}

export function UILogo({
  logo,
  href,
  isCollapsed,
  className,
  style,
}: UILogoProps) {
  const logoContainerStyle: CSSProperties = isCollapsed
    ? {
        width: SIDEBAR_DIMENSIONS.LOGO_COLLAPSED_WIDTH,
        marginLeft: SIDEBAR_DIMENSIONS.LOGO_COLLAPSED_MARGIN_LEFT,
        transition: `width ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1), margin ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
      }
    : {
        margin: "auto",
        transition: `margin ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
      };

  const wrapperStyle = {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    height: "30px",
  };

  const containerStyle: CSSProperties = {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    ...logoContainerStyle,
    ...style,
  };

  const logoWrapper = <Box sx={wrapperStyle}>{logo}</Box>;

  if (href) {
    // Check if href is an external URL
    const isExternalUrl =
      href.startsWith("http://") || href.startsWith("https://");

    if (isExternalUrl) {
      return (
        <a
          href={href}
          className={className}
          style={containerStyle}
          onClick={(e) => {
            e.preventDefault();
            window.location.href = href;
          }}
        >
          {logoWrapper}
        </a>
      );
    }

    return (
      <Link to={href} className={className} style={containerStyle}>
        {logoWrapper}
      </Link>
    );
  }

  return (
    <Box className={className} style={containerStyle}>
      {logoWrapper}
    </Box>
  );
}
